<template>
    <div ref="datepicker" class="control has-icons-left">
        <input
            type="text"
            class="input"
            :class="cssClass"
            v-model="date"
            readonly
            @click="isActive = !isActive"
            :disabled="disabled"
        />

        <span class="icon is-left">
            <i class="fad fa-calendar"></i>
        </span>

        <CalendarPanel
            v-model="date"
            :isActive="isActive"
            :minDate="minDate"
            :maxDate="maxDate"
            @close="close"
        />
    </div>
</template>

<script>
import CalendarPanel from "./date/CalendarPanel";

export default {
    name: "zfk-datepicker",
    components: {
        CalendarPanel,
    },
    props: {
        value: {
            type: String,
        },
        minDate: {
            type: String,
            default: null,
        },
        maxDate: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        cssClass: {
            type: Object,
        },
        remove: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            date: null,
            isActive: false,
        };
    },
    watch: {
        date(newValue) {
            if (newValue !== "") {
                this.isActive = false;
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            let date =
                newValue !== undefined && newValue !== null ? newValue : "";
            this.date = date;
        },
    },
    methods: {
        close() {
            if (this.remove) {
                this.date = null;
            }
            this.isActive = false;
        },
    },
    mounted() {
        let date =
            this.value !== undefined && this.value !== null ? this.value : "";
        this.date = date;
    },
};
</script>
